import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import { Box } from '@material-ui/core'
import Pagination from '@material-ui/lab/Pagination'
import PaginationItem from '@material-ui/lab/PaginationItem'

const createPaginationUrl = (currentPage, basePath) => (
  item
) => {
  const path =
    // eslint-disable-next-line no-nested-ternary
    item.page === currentPage
      ? ''
      : item.page === 1
      ? `${basePath}`
      : `${basePath}/${item.page}`

  return (
    <PaginationItem to={path} component={Link} {...item} />
  )
}

const getPages = (total, perPage) => {
  const n = Math.ceil(total / perPage)
  return n === 0 ? 1 : n
}

const ArchivePagination = ({
  pageInfo,
  relativePath,
  perPage,
}) => {
  return (
    <Box mt={5}>
      <Pagination
        page={pageInfo.currentPage}
        count={getPages(pageInfo.totalCount, perPage)}
        renderItem={createPaginationUrl(
          pageInfo.currentPage,
          relativePath
        )}
      />
    </Box>
  )
}

ArchivePagination.defaultProps = {
  pageInfo: {
    currentPage: 1,
    totalCount: 1,
  },
  relativePath: '/',
}

ArchivePagination.propTypes = {
  pageInfo: PropTypes.shape({
    currentPage: PropTypes.number,
    totalCount: PropTypes.number,
  }),
  relativePath: PropTypes.string,
  perPage: PropTypes.number.isRequired,
}

export default ArchivePagination
